export default {
    parts: [
        'mapDesktopWrapper',
        'contentPanel',
        'productInfoWrapper',
        'productName',
        'productDetailsStack',
        'searchIconElement',
        'searchButton',
        'searchResultsRow',
        'currentLocationButton',
        'currentLocationIcon',
        'storesCount',
        'locationPermissionWrapper',
        'locationPermissionTitle',
        'locationPermissionDescription',
        'mobileTabs',
        'mobileListTabPanel',
        'mobileMapTabPanel',
        'detailOverlay',
        'detailHeader',
        'detailIconButton',
        'detailNameRow',
        'detailStoreName',
        'detailDistance',
        'detailAddress',
        'detailAvailabilityRow',
        'detailAvailabilityDot',
        'detailAvailabilityText',
        'detailDesktopDirections',
        'detailContent',
        'detailSection',
        'detailParkingSection',
        'detailSectionTitle',
        'detailSectionValue',
        'detailSectionValueHours',
        'detailHideOnDesktop',
        'detailMobileButtonsWrapper',
        'detailMobileCallButton',
        'detailMobileDirectionsButton'
    ],
    baseStyle: {
        mapDesktopWrapper: {
            flex: 1
        },
        contentPanel: {
            maxWidth: {md: '448px'},
            w: '100%',
            p: {base: '84px 16px 0', md: '100px 24px 24px'},
            overflow: {md: 'auto'},
            height: {md: 'calc(100vh)'}
        },
        productInfoWrapper: {
            mb: 14,
        },
        productName: {
            textStyle: 'labelSmMd',
            mb: 3
        },
        productDetailsStack: {
            spacing: 0,
            textStyle: 'bodySmRegular'
        },
        searchIconElement: {
            width: 'auto',
            top: '0'
        },
        searchButton: {
            _hover: {bg: 'transparent'},
            color: 'webTypo.textPrimary'
        },
        searchResultsRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mt: 2.5
        },
        currentLocationButton: {
            display: 'flex',
            alignItems: 'center',
            textStyle: 'bodyXsRegular',
            flexShrink: 0,
            height: 'unset',
            cursor: 'pointer'
        },
        currentLocationIcon: {
            mr: 1
        },
        storesCount: {
            textStyle: 'bodyXsRegular'
        },
        locationPermissionWrapper: {
            flexDirection: 'column',
            gap: 3,
            pt: '26px'
        },
        locationPermissionTitle: {
            textStyle: 'labelXs'
        },
        locationPermissionDescription: {
            textStyle: 'bodyXsRegular'
        },
        mobileTabs: {
            borderColor: 'webTheme.strokeTertiary',
            mx: {base: '-16px'},
            mt: 12
        },
        mobileListTabPanel: {
            p: '0 16px'
        },
        mobileMapTabPanel: {
            p: 0
        },
        detailOverlay: {
            position: 'fixed',
            top: 0,
            right: 0,
            width: '100%',
            maxWidth: {md: '448px'},
            height: '100vh',
            bg: 'white',
            zIndex: 20,
            p: {base: 4, lg: 6},
            overflowY: 'auto',
            display: 'flex',
            flexDirection: 'column'
        },
        detailHeader: {
            justifyContent: 'space-between',
            p: {base: '0 16px 16px 16px', lg: '0 24px 24px 24px'},
            mb: {base: 4, lg: 6},
            mx: {base: '-16px', lg: '-24px'},
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
        },
        detailIconButton: {
            _hover: {bg: 'none'},
            px: 0,
            size: 'sm',
            border: 0,
            color: 'webTypo.textPrimary',
            backgroundColor: 'webTypo.textOnColor'
        },
        detailNameRow: {
            mb: 2,
            justifyContent: 'space-between'
        },
        detailStoreName: {
            textStyle: 'webH3'
        },
        detailDistance: {
            textStyle: 'bodyXsRegular'
        },
        detailAddress: {
            textStyle: 'bodySmRegular'
        },
        detailAvailabilityRow: {
            mt: 2,
            justifyContent: 'space-between'
        },
        detailAvailabilityDot: {
            w: '6px',
            h: '6px'
        },
        detailAvailabilityText: {
            textStyle: 'bodyXsRegular'
        },
        detailDesktopDirections: {
            border: 0
        },
        detailContent: {
            pt: 8,
            fontSize: 'md',
            display: 'flex',
            flexDirection: 'column',
            flex: 1
        },
        detailSection: {
            align: 'start',
            mb: 8,
            gap: 0
        },
        detailParkingSection: {
            align: 'start',
            gap: 0
        },
        detailSectionTitle: {
            mb: 2,
            textStyle: 'webH3'
        },
        detailSectionValue: {
            textStyle: 'bodySmRegular'
        },
        detailSectionValueHours: {
            textTransform: 'uppercase'
        },
        detailHideOnDesktop: {
            width: '100%',
            mt: 'auto',
            bg: 'white',
            pt: 4,
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary'
        },
        detailMobileButtonsWrapper: {
            mt: 0,
              alignItems: 'stretch',
            gap: 2
        },
        detailMobileCallButton: {
              flex: '1 1 0',
              minWidth: 0,
              width: 'auto',
              height: 'auto',
              minHeight: '48px',
              whiteSpace: 'normal',
              overflowWrap: 'anywhere',
              textAlign: 'center',
            _hover: {textDecoration: 'none'}
        },
        detailMobileDirectionsButton: {
              flex: '1 1 0',
              minWidth: 0,
              width: 'auto',
              height: 'auto',
              minHeight: '48px',
              whiteSpace: 'normal',
              overflowWrap: 'anywhere',
              textAlign: 'center'
        }
    }
}
